import { Hammer } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function WorkOrdersPage() {
  return (
    <PhaseStubPage
      title="Work orders"
      phase={3}
      modules={[
        'WO authoring from BOM + routing',
        'Touch-friendly shop-floor view (employee role)',
        'Auto-consume components, auto-produce outputs',
        'Scrap tracking per operation',
      ]}
      icon={Hammer}
    />
  );
}
